import { useEffect, useId, useRef, useState } from 'react';
import {
  PRIHVACENE_DATOTEKE,
  pripremiDokument,
  prikazVelicine,
} from '../lib/dokumenti';
import Ikona from './Ikona';

function Slicica({ datoteka }) {
  const [url, postaviUrl] = useState('');
  useEffect(() => {
    const u = URL.createObjectURL(datoteka);
    postaviUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [datoteka]);
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Otvori fotografiju za provjeru čitljivosti"
    >
      <img
        className="slicica-dokumenta"
        src={url}
        alt="Pregled snimljene stranice"
      />
    </a>
  );
}
export default function OdabirDokumenata({
  datoteke,
  naPromjenu,
  zauzeto,
  naPripremu,
}) {
  const kamera = useId();
  const odabir = useId();
  const zakljucano = useRef(false);
  const [priprema, postaviPriprema] = useState(false);
  const [greska, postaviGreska] = useState('');
  const dodaj = async (e) => {
    const izabrane = Array.from(e.target.files ?? []);
    e.target.value = '';
    if (!izabrane.length || zakljucano.current) return;
    if (datoteke.length + izabrane.length > 10) {
      postaviGreska('Priloži najviše deset datoteka odjednom.');
      return;
    }
    zakljucano.current = true;
    postaviPriprema(true);
    naPripremu?.(true);
    postaviGreska('');
    try {
      const nove = [];
      for (const d of izabrane) nove.push(await pripremiDokument(d));
      const sve = [...datoteke];
      for (const d of nove)
        if (!sve.some((s) => s.sha256 === d.sha256)) sve.push(d);
      if (sve.length !== datoteke.length + nove.length)
        postaviGreska('Ponovljene datoteke već su u odabiru.');
      naPromjenu(sve);
    } catch (e) {
      postaviGreska(e.message);
    } finally {
      zakljucano.current = false;
      postaviPriprema(false);
      naPripremu?.(false);
    }
  };
  return (
    <div className="odabir-dokumenata">
      <div className="gumbi-dokumenata">
        <label
          className={`gumb ${zauzeto || priprema ? 'onemoguceno' : ''}`}
          htmlFor={kamera}
        >
          <Ikona naziv="kamera" /> Fotografiraj / skeniraj
        </label>
        <input
          className="skriveni-odabir"
          id={kamera}
          type="file"
          accept="image/*"
          capture="environment"
          aria-label="Fotografiraj dokument kamerom"
          onChange={dodaj}
          disabled={zauzeto || priprema}
        />
        <label className="gumb sek" htmlFor={odabir}>
          <Ikona naziv="dokument" /> Odaberi PDF ili fotografije
        </label>
        <input
          className="skriveni-odabir"
          id={odabir}
          type="file"
          accept={PRIHVACENE_DATOTEKE}
          multiple
          aria-label="Odaberi dokumente za prilaganje"
          onChange={dodaj}
          disabled={zauzeto || priprema}
        />
      </div>
      <p className="pomoc-dokumenata">
        PDF, JPG, PNG ili WEBP · do 10 MB po datoteci · do 10 stranica/datoteka.
        Na mobitelu fotografiraj svaku stranicu zasebno. Provjeri čitljivost
        prije spremanja.
      </p>
      {priprema && <p role="status">Pripremam fotografije i dokumente…</p>}
      {greska && (
        <p className="poruka greska" role="alert">
          {greska}
        </p>
      )}
      {!!datoteke.length && (
        <ul className="odabrani-dokumenti">
          {datoteke.map((d, i) => (
            <li key={d.id}>
              {d.mime.startsWith('image/') ? (
                <Slicica datoteka={d.datoteka} />
              ) : (
                <span className="ikona-ploha">
                  <Ikona naziv="dokument" />
                </span>
              )}
              <div>
                <strong>
                  {i + 1}. {d.izvorni_naziv}
                </strong>
                <small>
                  {prikazVelicine(d.velicina)} · odabrano, još nije poslano
                </small>
              </div>
              <button
                className="tekst-gumb"
                type="button"
                disabled={zauzeto || priprema}
                onClick={() =>
                  naPromjenu(datoteke.filter((s) => s.id !== d.id))
                }
                aria-label={`Ukloni odabranu datoteku ${i + 1}`}
              >
                Ukloni
              </button>
            </li>
          ))}
        </ul>
      )}
      {!!datoteke.length && (
        <p className="pomoc-dokumenata">
          Odabrane datoteke ostaju samo u ovoj kartici do slanja. Nakon
          osvježavanja stranice treba ih ponovno odabrati.
        </p>
      )}
    </div>
  );
}
